import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flexbtwn" }
const _hoisted_2 = { class: "gfu-btn__text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_add_product_to_cart = _resolveComponent("add-product-to-cart")
  const _component_product_card = _resolveComponent("product-card")
  const _component_product_card_list_provider = _resolveComponent("product-card-list-provider")

  return (_openBlock(), _createBlock(_component_product_card_list_provider, { products: $props.products }, {
    default: _withCtx(({ productList, onItemAdded, getAddProductToCartModel }) => [
      _createElementVNode("ul", {
        class: _normalizeClass($options.productCardListClasses)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList, (product) => {
          return (_openBlock(), _createElementBlock("li", {
            key: product.productId,
            class: "gfu-grid__cell gfu-1of1 gfu-1of2--m gfu-1of3--l"
          }, [
            _createVNode(_component_product_card, _mergeProps({ ref_for: true }, product, {
              context: "modal",
              "show-abstract": false
            }), {
              action: _withCtx(() => [
                _createVNode(_component_add_product_to_cart, _mergeProps({ ref_for: true }, getAddProductToCartModel(product), {
                  "text-align": "center",
                  "button-text": _ctx.Resources.Product.ProductCardAddToOrderButton,
                  onItemAdded: onItemAdded
                }), {
                  buttonContents: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.Resources.Product.ProductCardAddToOrderButton), 1 /* TEXT */),
                      _createVNode(_component_base_icon, {
                        "icon-namespace": "ga",
                        name: "plus-bold-icon",
                        class: "_ml-1"
                      })
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 16 /* FULL_PROPS */, ["button-text", "onItemAdded"])
              ]),
              _: 2 /* DYNAMIC */
            }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["products"]))
}